import { render, staticRenderFns } from "./SupportDashboardLayout.vue?vue&type=template&id=e92108ca&scoped=true&"
import script from "./SupportDashboardLayout.vue?vue&type=script&lang=ts&"
export * from "./SupportDashboardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SupportDashboardLayout.vue?vue&type=style&index=0&id=e92108ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92108ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VApp,VDialog})
